import { REFRESH_TOKEN, REFRESH_TOKEN_DONE, LOGOUT, REFRESH_TOKEN_ERROR, LOGOUT_DONE, LOGOUT_ERROR, LOGIN, LOGIN_DONE, LOGIN_ERROR } from './actionTypes';
export const refreshToken = () => ({ type: REFRESH_TOKEN });
export const refreshTokenDone = (data) => ({
    type: REFRESH_TOKEN_DONE,
    data
});
export const refreshTokenError = (data = 'auth_error') => ({
    type: REFRESH_TOKEN_ERROR,
    errorMessage: data
});
export const logout = () => ({ type: LOGOUT });
export const logoutDone = () => ({ type: LOGOUT_DONE });
export const logoutError = (data = 'auth_error') => ({
    type: LOGOUT_ERROR,
    errorMessage: data
});
export const login = () => ({ type: LOGIN });
export const loginDone = (data) => ({
    type: LOGIN_DONE,
    data
});
export const loginError = (data = 'auth_error') => ({
    type: LOGIN_ERROR,
    errorMessage: data
});
//# sourceMappingURL=actionCreators.js.map